import React, { useState } from 'react';
import { Modal, Button, Space } from 'antd';
import { CheckCircleOutlined, CloseOutlined } from '@ant-design/icons';

const SignatureSuccessPopup = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [countdown, setCountdown] = useState(5);
  const [isClosing, setIsClosing] = useState(false);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          setIsClosing(true);
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleOk = () => {
    setIsVisible(false);
  };

  const handleCancel = () => {
    setIsVisible(false);
  };

  return (
    <div className="app-container">
      <style jsx>{`
        .app-container {
          padding: 50px;
          text-align: center;
          min-height: 100%;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .success-modal .ant-modal-content {
          border-radius: 24px;
          overflow: hidden;
          box-shadow: 0 32px 96px rgba(0, 0, 0, 0.12);
          border: none;
          backdrop-filter: blur(20px);
          background: rgba(255, 255, 255, 0.95);
        }

        .success-modal .ant-modal-header {
          display: none;
        }

        .success-modal .ant-modal-close {
          display: none;
        }

        .success-modal .ant-modal-body {
          padding: 60px 40px;
          text-align: center;
          background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        }

        .success-icon {
          font-size: 96px;
          color: #22c55e;
          margin-bottom: 32px;
          animation: scaleIn 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        @keyframes scaleIn {
          0% {
            transform: scale(0) rotate(180deg);
            opacity: 0;
          }
          100% {
            transform: scale(1) rotate(0deg);
            opacity: 1;
          }
        }

        .success-title {
          font-size: 32px;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 16px;
          letter-spacing: -0.02em;
        }

        .success-message {
          font-size: 18px;
          color: #64748b;
          line-height: 1.6;
          margin-bottom: 24px;
          max-width: 320px;
          margin-left: auto;
          margin-right: auto;
        }

        .auto-close-message {
          font-size: 14px;
          color: #94a3b8;
          font-style: italic;
          margin-top: 16px;
        }

        .countdown {
          font-weight: 600;
          color: #22c55e;
        }

        .closing-message {
          font-size: 14px;
          color: #f59e0b;
          font-weight: 600;
          margin-top: 16px;
          animation: pulse 1s infinite;
        }

        .success-details {
          background: #f8f9fa;
          border-radius: 10px;
          padding: 20px;
          margin-bottom: 30px;
          border-left: 4px solid #4CAF50;
        }

        .detail-item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          font-size: 14px;
        }

        .detail-label {
          font-weight: 600;
          color: #333;
        }

        .detail-value {
          color: #666;
        }

        .success-modal .ant-modal-footer {
          border-top: none;
          padding: 0 30px 30px;
          text-align: center;
        }

        .action-buttons {
          display: flex;
          gap: 15px;
          justify-content: center;
        }

        .primary-button {
          background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
          border: none;
          color: white;
          padding: 16px 48px;
          border-radius: 16px;
          font-weight: 600;
          font-size: 16px;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          box-shadow: 0 8px 32px rgba(34, 197, 94, 0.3);
          position: relative;
          overflow: hidden;
        }

        .primary-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 48px rgba(34, 197, 94, 0.4);
        }

        .primary-button:active {
          transform: translateY(0);
        }

        .primary-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
          transition: left 0.5s;
        }

        .primary-button:hover::before {
          left: 100%;
        }

        .secondary-button {
          background: white;
          border: 2px solid #e0e0e0;
          color: #666;
          padding: 12px 30px;
          border-radius: 25px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .secondary-button:hover {
          border-color: #4CAF50;
          color: #4CAF50;
          transform: translateY(-2px);
        }

        .pulse-effect {
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
          100% {
            transform: scale(1);
          }
        }
      `}</style>

      {/* Demo Button */}
      <div style={{ opacity: 0.7, fontSize: '14px', color: 'white' }}>
        Signature Success Popup (Auto-displayed)
      </div>

      {/* Success Modal */}
      <Modal
        open={isVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        className="success-modal"
        centered
        width={460}
        footer={null}
        closable={false}
        maskClosable={false}
      >
        <div className="success-icon pulse-effect">
          <CheckCircleOutlined />
        </div>
        
        <div className="success-title">
          Your signature has been submitted!
        </div>
        
        <div className="success-message">
          Your signature has been successfully submitted and verified.
        </div>

        {!isClosing ? (
          <div className="auto-close-message">
            Please do not close this window. It will automatically close in <span className="countdown">{countdown}</span> seconds.
          </div>
        ) : (
          <div className="closing-message">
            Closing...
          </div>
        )}
      </Modal>
    </div>
  );
};

export default SignatureSuccessPopup;